import React, { useCallback, useState, useMemo } from "react";
import { Avatar, Textarea, DatePicker, Input, Button, Card, CardHeader, Link, Image, Divider, CardBody, CardFooter } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { getLocalTimeZone, today, now } from "@internationalized/date";
import { useClient, useWriteContract } from "wagmi";
import { ProjectShowAddress } from "../../constants";
import ProjectShowAbi from "../../assets/abis/ProjectShow.json";
import { waitForTransactionReceipt } from "viem/actions";
import MyProjectShow from "../../components/MyProjectShow";


function getTimestamp(dateString) {
  // 原始时间字符串

  // 去掉时区部分并将字符串转换为Date对象
  const cleanDateString = dateString.replace(/\[.*\]/, '');
  console.log(cleanDateString)
  const date = new Date(cleanDateString);

  // 获取时间戳（以毫秒为单位）
  const timestamp = date.getTime();

  console.log(timestamp);
  return parseInt(timestamp / 1000)
}

function Home() {
  const { t } = useTranslation()
  const [srcUrl, setsrcUrl] = useState('/logo192.png')
  const { writeContractAsync } = useWriteContract()
  const client = useClient()
  const [depositing, setDepositing] = useState(false)
  const [starttime, setstarttime] = useState(()=>getTimestamp(now().toString()))
  const [slippage, setslippage] = useState('')
  const [telegram, settelegram] = useState('')
  const [Discord, setDiscord] = useState('')
  const [intro, setintro] = useState('')
  const [X, setX] = useState('')
  const [addr, setaddr] = useState('')
  const onDeposit = useCallback(async () => {
    setDepositing(true)
    // 
    try {
      const hash = await writeContractAsync({
        abi: ProjectShowAbi,
        address: ProjectShowAddress,
        functionName: 'add',
        args: [
          starttime, srcUrl, slippage, telegram, X, Discord, intro, addr
        ]
      })

      await waitForTransactionReceipt(client, {
        hash,
        confirmations: 1,
      })

    } catch (e) {
      console.log(e)
    } finally {
      setDepositing(false)
    }
  }, [starttime, srcUrl, slippage, telegram, X, Discord, intro, addr, client, writeContractAsync])

  // const validateEmail = /^0x[a-fA-F0-9]{40}$/.test(addr);
  const validatetelegram = (value) => value.match(/^(https:\/\/t\.me\/|https:\/\/telegram\.me\/)[a-zA-Z0-9_]{5,32}$/);
  const validateEmail = (value) => value.match(/^0x[a-fA-F0-9]{40}$/);
  const isInvalid = useMemo(() => {
    if (addr === "") return false;

    return validateEmail(addr) ? false : true;
  }, [addr]);
  const telegramisInvalid = useMemo(() => {
    if (telegram === "") return false;

    return validatetelegram(telegram) ? false : true;
  }, [telegram]);
  console.log(getLocalTimeZone())
  return (
    <div className="container mx-auto max-w-lg ">
      <Card className="mx-4 rounded-lg ">
        <CardHeader className="flex gap-3 m-auto">
          <div className="flex items-center">
            <Avatar
              src={srcUrl}
              className="dark:bg-primary-foreground"
              size="lg"
            />
          </div>
        </CardHeader>
        <CardFooter>
          <Button
            size={'lg'}
            className={'w-full disabled:grayscale disabled:pointer-events-none dark:bg-primary-foreground'}
            color={"primary"}
            variant={'flat'}
            isLoading={depositing}
            onPress={onDeposit}
          >
            提交
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}

export default Home